export default __webpack_public_path__ + "static/media/add-folder-white.125d1c3f.svg";